module.exports = __webpack_public_path__ + "static/media/m.19ccb369.m4a";